module.exports = __webpack_public_path__ + "img/Item_View.8af3822e.svg";